import "./create-user-form.css"
import { InputText } from "@/components/input-text";
import { Button } from "@/components/button";
import { useEffect, useState } from "react";
import { validateCreateUserForm, validateInviteUserForm } from "@/utils/form";
import { Dropdown } from "@/components/dropdown";
import type { Role } from "../../pages/admin-users/viewModel";


interface CreateUserFormProps<T> {
    roles: Role[]
    isInvite?: boolean;
    onCancel?: () => void;
    onSubmit?: (value: T) => void;
}

export function CreateUserForm<T extends Record<string, any>>({
    isInvite=false,
    roles,
    onCancel, 
    onSubmit, 
}: CreateUserFormProps<T>) {
  
    const [errors, setErrors] = useState<any>({
        email: "",
        password: "",
        full_name: "",
        role_id: ""
      });
   
    const [values, setValues] = useState<Partial<T>>({} as T)

    useEffect(() => {
        const viewerRole = roles.find((role) => role.name === "viewer");
      
        if (viewerRole) {
          setValues((prev) => ({
            ...prev,
            role_id: viewerRole.id,
          }));
        }
      }, [roles]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = isInvite ? validateInviteUserForm(values) : validateCreateUserForm(values);
    
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return
        }
        setErrors({})
        onSubmit(values as T);
    }
    
    return  <form onSubmit={handleSubmit}  className="form-create-user">
         <InputText 
            error={errors["email"]} 
            key={"email"} 
            label={"E-mail"} 
            name={"email"} 
            value={String(values["email"] ?? "")}
            onChange={(e) =>
                setValues((prev) => ({
                ...prev,
                email: e.target.value,
                }))
            }
            placeholder={"E-mail"}
            />
       {!isInvite && <InputText 
            error={errors["password"]} 
            key={"password"} 
            label={"Mot de Passe"} 
            name={"password"} 
            value={String(values["password"] ?? "")}
            onChange={(e) =>
                setValues((prev) => ({
                ...prev,
                password: e.target.value,
                }))
            }
            password={true}
            placeholder={"Mot de passe"}
        />}
        <InputText 
            error={errors["full_name"]} 
            key={"full_name"} 
            label={"Nom Complet"} 
            name={"full_name"} 
            value={String(values["full_name"] ?? "")}
            onChange={(e) =>
                setValues((prev) => ({
                ...prev,
                full_name: e.target.value,
                }))
            }
            placeholder={"Nom Complet"}
            />
        <Dropdown
            className="select-role-create-user"
            inputLabel="Rôle"
            label={roles.find((role) => role.id === values.role_id)?.name ?? "viewer"}
            options={roles.map((role) => role.name)}
            value={ roles.find((role) => role.id === values.role_id)?.name ?? "viewer"}
            onChange={(value) => {
            const role = roles.find((role) => role.name === value);
                
            if (!role) return;
        
            setValues({
                ...values,
                role_id: role.id,
            });
            }}
        />
        <footer className="form-footer">
            <Button className="button-cancel" label={"Annuler"} onClick={onCancel} variant="secondary"></Button>
            <Button className="button-submit" label={isInvite ? "Inviter" : "Créer"} type="submit"></Button>
        </footer>
    </form>    
}